import React, { createContext, useState, PropsWithChildren, ReactNode } from "react";
import Modal from "@/components/Modal";
import type { ModalContextProps } from "@/types/providers/modal";

export const ModalContext = createContext<ModalContextProps | undefined>(undefined);

export function ModalProvider({ children }: PropsWithChildren) {
  const [visible, setVisible] = useState(false);
  const [content, setContent] = useState<ReactNode | null>(null);

  const openModal = (modalContent: ReactNode) => {
    setContent(modalContent);
    setVisible(true);
  };

  const closeModal = () => setVisible(false);
  const onDismiss = () => {};

  return (
    <ModalContext.Provider value={{ openModal, onDismiss, closeModal }}>
      {children}
      {visible && <Modal onUnmount={() => onDismiss?.()}>{content}</Modal>}
    </ModalContext.Provider>
  );
}
